export const buildDate: string = "2026-05-18 11:05:52";
export const appState:number = 1;
